import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ISSUES } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import { PageHeader, Kicker } from "@/components/Section";
import { Marquee } from "@/components/Marquee";

const IssueCard = ({ issue, i }) => (
  <Reveal delay={i * 0.08}>
    <Link to={`/issues/${issue.slug}`} data-testid={`issue-card-${issue.number}`} className="group block">
      <motion.div
        whileHover={{ y: -4 }}
        className="relative overflow-hidden gold-frame bg-charcoal transition-shadow duration-300 group-hover:shadow-[0_0_35px_rgba(201,162,39,0.18)]"
      >
        <div className="panel-mono relative h-80 overflow-hidden">
          <img src={issue.cover} alt={issue.title} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-onyx/70 to-transparent" />
          <div className="absolute left-3 top-3 border border-gold/50 bg-onyx/85 px-3 py-1 font-display text-xl uppercase tracking-tight text-goldlight">
            Issue #{issue.number}
          </div>
          <div className="absolute bottom-3 right-3 border border-silver/40 bg-onyx/85 px-2 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-silver">
            {issue.status}
          </div>
        </div>
        <div className="border-t border-gold/25 p-5">
          <div className="flex items-start justify-between gap-3">
            <h3 className="font-display text-3xl uppercase leading-none tracking-tight text-cream">{issue.title}</h3>
            <ArrowUpRight className="shrink-0 text-gold transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
          </div>
          <p className="mt-3 font-body text-sm leading-relaxed text-silver/75">{issue.summary}</p>
          <div className="mt-4 flex flex-wrap gap-2">
            {issue.disciplines.map((d) => (
              <span key={d} className="border border-gold/30 px-2 py-0.5 font-mono text-[10px] uppercase tracking-wide text-goldlight/80">{d}</span>
            ))}
          </div>
        </div>
      </motion.div>
    </Link>
  </Reveal>
);

export default function Campaigns() {
  return (
    <div className="bg-onyx text-cream">
      <PageHeader
        kicker="Campaign Archive"
        titleLines={["Collect the", "Issues."]}
        subtitle="Every campaign is a collectible Issue — one shared brief brought to life by a multidisciplinary crew. Tap in to see the work, the contributors, and the credits."
        dark
      />
      <Marquee items={["Issue 001", "Issue 002", "Issue 003", "Coming Soon"]} />

      <section className="grain-dark bg-onyx py-20 sm:py-28">
        <div className="relative mx-auto max-w-[1400px] px-4 sm:px-6">
          <Reveal><Kicker>The Issues</Kicker></Reveal>
          <div className="mt-10 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {ISSUES.map((issue, i) => (
              <IssueCard key={issue.slug} issue={issue} i={i} />
            ))}
            <Reveal delay={ISSUES.length * 0.08}>
              <div className="flex h-full min-h-[420px] flex-col items-center justify-center border border-dashed border-gold/40 bg-charcoal/50 p-8 text-center">
                <span className="font-display text-6xl text-gold-metallic">004</span>
                <p className="mt-3 font-head text-lg font-extrabold uppercase tracking-tight text-cream">Next Issue Loading</p>
                <p className="mt-2 font-body text-sm text-silver/60">New briefs drop each cohort. Subscribe to be first to know.</p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
